export default __webpack_public_path__ + "static/media/Howl of the Pack.36c7bcf1.jpg";